export const DICT = {
  CONTENT_SING: process.env.REACT_APP_TERM_CONTENT_SING || "Conteúdo",
  CONTENT_PLUR: process.env.REACT_APP_TERM_CONTENT_PLUR || "Conteúdos",
  METRIC_SING: process.env.REACT_APP_TERM_METRIC_SING || "Métrica",
  METRIC_PLUR: process.env.REACT_APP_TERM_METRIC_PLUR || "Métricas",
  REWARD: process.env.REACT_APP_TERM_REWARD || "Comissionamento",
  FORMAT_LABEL: process.env.REACT_APP_TERM_FORMAT || "Formato/Tipo",
  
  CARGOS_ETAPAS: process.env.REACT_APP_OPTIONS_CARGOS 
    ? process.env.REACT_APP_OPTIONS_CARGOS.split(',') 
    : ['ROTEIRISTA', 'COPYWRITER', 'DESIGNER', 'EDITOR'],
    
  TIPOS_CONTEUDO: process.env.REACT_APP_OPTIONS_TIPOS 
    ? process.env.REACT_APP_OPTIONS_TIPOS.split(',') 
    : ['SHORT', 'LONGO', 'ARTIGO', 'IMAGEM']
};